import React, {PureComponent} from 'react';
import LineChart from "../independentComponents/graphComponent";
import $ from "jquery";
import {confirmIdentity} from "../functions/api";
import Overlay from "ol/Overlay";
import {fromLonLat} from "ol/proj";
import Map from "ol/Map";
import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import View from "ol/View";
import flagIcon from "../../img/marshall.png";
import {getMiddleGPS} from "../functions/utils";
import parallel from "async/parallel";
import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";
import Alert from "react-s-alert";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

class PopoutPitDetail extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            pitData: null,
            orderedMetrics: [],
        };

        this.getPitTelemetry = this.getPitTelemetry.bind(this);
        this.updateShow = this.updateShow.bind(this);
        this.setupMap = this.setupMap.bind(this);
        this.sortMetrics = this.sortMetrics.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {
        $(".loading").fadeIn();
        const helper = this;
        confirmIdentity(this.props.cookies.get("authToken"), this.props.match.params.userID, this.props.match.params.eventID, () => {
            parallel([
                function (callback) {
                    helper.getPitTelemetry((status) => {
                        helper.sortMetrics();
                        callback(null, status);
                    });
                },
                function (callback) {
                    helper.setupMap((status) => {
                        callback(null, status);
                    });
                }
            ], function (err, result) {
                $(".loading").fadeOut();
            });
        });
    }

    /* GET DATA */
    setupMap(callback) {
        this.map = new Map({
            target: "map",
            layers: [
                new TileLayer({
                    source: new XYZ({
                        attributions: 'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer">ArcGIS</a>',
                        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
                    })
                }),
            ],
            view: new View({
                center: fromLonLat(getMiddleGPS(this.props.match.params.pitEntryLng, this.props.match.params.pitEntryLat, this.props.match.params.pitExitLng, this.props.match.params.pitExitLat)),
                zoomFactor: 1.1,
                zoom: parseInt(this.props.match.params.mapZoomLevel) + 8,
                maxZoom: 141,
                rotation: parseFloat(this.props.match.params.mapRotation),
            }),
            loadTilesWhileAnimating: true,
            loadTilesWhileInteracting: true,
        });

        // Place PIT entry/exit markers
        const pitEntry = $('' +
            '<div class="sectorFlag" style="height: 65px;width: 80px;">' +
            '<span class="sectorText" style="font-size: 12px">' + this.props.t("entry").toUpperCase() + '</span>' +
            '<img style="height: 100%; width:100%" src="' + flagIcon + '" alt="sector"/>' +
            '</div>' +
            '').get(0);

        this.map.addOverlay(
            new Overlay({
                id: "pitEntryMarker",
                element: pitEntry,
                position: fromLonLat([this.props.match.params.pitEntryLng, this.props.match.params.pitEntryLat]),
                offset: [-2, 4],
                positioning: 'bottom-left',
            })
        );
        const pitExit = $('' +
            '<div class="sectorFlag" style="height: 65px;width: 80px;">' +
            '<span class="sectorText" style="font-size: 12px">' + this.props.t("exit").toUpperCase() + '</span>' +
            '<img style="height: 100%; width:100%" src="' + flagIcon + '" alt="sector"/>' +
            '</div>' +
            '').get(0);

        this.map.addOverlay(
            new Overlay({
                id: "pitExitMarker",
                element: pitExit,
                position: fromLonLat([this.props.match.params.pitExitLng, this.props.match.params.pitExitLat]),
                offset: [-2, 4],
                positioning: 'bottom-left',
            })
        );

        // Place vehicle marker
        const innerDiv = $('' +
            '<div id="car_id_marker">' +
            '   <span class="fa-stack carPin">' +
            '       <i class="fa fa-circle fa-stack-2x" style="color: #b00b0d;line-height: inherit"/><i class="fa fa-car fa-stack-1x fa-inverse" style="font-size:15px;margin:inherit"/>' +
            '   </span>' +
            '</div>').get(0);

        this.setState({
            marker: new Overlay({
                id: "carMarker_Details",
                element: innerDiv,
                position: fromLonLat([0, 0]),
                offset: [0, 10],
                positioning: 'bottom-center',
            })
        }, () => {
            this.map.addOverlay(this.state.marker);
            callback("ok");
        });
    }

    getPitTelemetry(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getPitFullDetails',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                pitEntry: helper.props.match.params.entry,
                pitExit: helper.props.match.params.exit,
                sessionID: helper.props.match.params.sessionID,
                carID: helper.props.match.params.carID,
            },
            success: function (data) {
                if (data !== undefined && Object.keys(data).length > 0) {
                    helper.setState({
                        pitData: data,
                    }, () => {
                        callback("ok");
                    });
                } else {
                    Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("noPitTelemetry") + '</span>', {
                        position: 'top-right',
                        effect: 'genie',
                        beep: false,
                        timeout: 15000,
                        offset: 150
                    });
                    callback("nok");
                }
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    updateShow(index) {
        this.state.marker.setPosition(
            fromLonLat([
                this.state.pitData.data.coords[index][0],
                this.state.pitData.data.coords[index][1]
            ])
        );
    }

    sortMetrics() {
        let array = [];
        for (let i = 0; i < Object.keys(this.state.pitData.labels).length; i++) {
            array[this.state.pitData.labels[Object.keys(this.state.pitData.labels)[i]].order_no] = Object.keys(this.state.pitData.labels)[i];
        }
        let filtered = array.filter(function (el) {
            return el != null;
        });
        this.setState({
            orderedMetrics: filtered,
        });
    }

    /* RENDER */
    render() {
        return (
            <div className={"container-fluid"} style={{margin: 10, padding: 0}}>
                <Alert stack={{limit: 10}} html={true}/>
                <div className="loading">
                    <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                </div>
                <div className={"row w3-animate-fading"} style={{margin: 10}}>
                    {this.state.header}
                    <div className={"col-xs-12"}>
                        <div style={{
                            marginLeft: 15,
                            height: 300,
                            width: "100%"
                        }} id={"map"}/>
                    </div>
                </div>
                {this.state.pitData ? (
                    this.state.orderedMetrics.map((tag) => {
                        if (Object.keys(this.state.pitData.maxes).length > 0) {
                            return (
                                <div key={"graph_" + tag} className={"col-md-12"} style={{padding: 0, width: "100%"}}>
                                    <LineChart
                                        dataName={this.state.pitData.labels[tag][localStorage.getItem("i18nextLng")]}
                                        data={this.state.pitData.data[tag]}
                                        hoverTriggerIndex={[true, false]}
                                        minYAxis={this.state.pitData.labels[tag].unit === "%" ? 0 : 0}
                                        maxYAxis={this.state.pitData.labels[tag].unit === "%" ? 100 : this.state.pitData.maxes[tag]}
                                        unit={this.state.pitData.labels[tag].unit}
                                        showPercent={this.state.showPercent}
                                        updateShow={this.updateShow}
                                    />
                                </div>
                            );
                        } else {
                            return null;
                        }
                    })
                ) : null}
            </div>
        );
    }
}

export default withTranslation("translations")(withCookies(PopoutPitDetail));
